import * as React from 'react';
import { styled } from '@mui/system';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import CoffeeMakerIcon from '@mui/icons-material/CoffeeMaker';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import Background from '../../../assets/images/background.jpeg';

const Sidebar = styled('nav')(({ theme }) => ({
  marginTop: '60px',
  minWidth: '60px',
  height: 'calc(100vh - 60px)',
  backgroundImage: `url(${Background})`,
  position: 'fixed',
  zIndex: 2,
  filter: 'drop-shadow(2px 0px 2px rgba(0, 0, 0, 0.3))',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const InnerYellowBorder = styled('div')({
  width: '50px',
  height: 'calc(100vh - 70px)',
  margin: '5px',
  border: '1px solid #AA9178',
});

const IconsContainer = styled('ul')({
  marginTop: '40px',
  listStyleType: 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: 0,
  gap: '15px',
});

const ListItems = styled('li')({
  display: 'flex',
  justifyContent: 'center',
});

const LinkItems = styled('a')({
  '& svg': {
    fontSize: 25,
  },
  color: '#DADADA',
});

const SideBarIcon = () => {
  return (
    <IconsContainer>
      <ListItems>
        <LinkItems href="/search">
          <LocalCafeIcon />
        </LinkItems>
      </ListItems>
      <ListItems>
        <LinkItems href="/note/gallery">
          <ExploreRoundedIcon />
        </LinkItems>
      </ListItems>
      <ListItems>
        <LinkItems>
          <CoffeeMakerIcon />
        </LinkItems>
      </ListItems>
    </IconsContainer>
  );
};

const LeftBar = () => {
  return (
    <Sidebar>
      <InnerYellowBorder>
        <SideBarIcon />
      </InnerYellowBorder>
    </Sidebar>
  );
};

export default LeftBar;
